import { render, staticRenderFns } from "./MedicalCaseListView.vue?vue&type=template&id=bbc5c262"
import script from "./MedicalCaseListView.vue?vue&type=script&lang=js"
export * from "./MedicalCaseListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports